module.exports = __webpack_public_path__ + "img/acslogo.6713ebae.svg";